import * as React from 'react';
import * as _ from 'underscore';
import * as moment from 'moment';
import { sprintf } from 'sprintf';

import BillRepository from '../../repositories/BillRepository';
import Bill from '../../models/Bill';
import Room from '../../models/Room';

import './reservation.less';

interface P {
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    rooms: Room[];
    guests: { [name: string]: number };
    inc: (room: Room) => void;
    dec: (room: Room) => void;
}

interface S {
    bill?: Bill;
}

export default class Reservation extends React.Component<P, S> {

    static contextTypes: React.ValidationMap<any> = {
        bill_repository: React.PropTypes.object
    }

    context: {
        bill_repository: BillRepository;
    };

    constructor( props: P, context: any ) {
        super( props, context );

        this.state = { bill: undefined };
    }

    componentDidMount() {
        this.quote( this.props );
    }

    componentWillReceiveProps( nextProps: P ) {
        this.quote( nextProps );
    }

    private quote_sn_: string;

    private quote( props: P ) {
        let q = this.quote_sn_ = _.uniqueId( 'quote_' );
        this.setState({ bill: undefined });
        this.context.bill_repository.
             quote( props.checkIn, props.checkOut, props.rooms, props.guests ).
             done( data => q !== this.quote_sn_ || this.setState({ bill: data }) );
    }

    render() {
        let summary = <div className="ui active centered inline loader"></div>;
        if ( this.state.bill )
            summary = (
                <table>
                  <tbody>
                    <tr>
                      <th>Room Rate</th>
                      <td>${ sprintf('%.2f', this.state.bill.roomRate / 100) }</td>
                    </tr>
                    <tr>
                      <th>Taxes & Fees</th>
                      <td>${ sprintf('%.2f', this.state.bill.tax / 100) }</td>
                    </tr>
                    <tr className="total">
                      <th>
                        Grand Total
                      </th>
                      <td>$<b>{ sprintf('%.2f', this.state.bill.total / 100) }</b></td>
                    </tr>
                  </tbody>
                </table>
            );

        const { checkIn, checkOut, rooms, guests, inc, dec } = this.props;
        return (
            <div className="reservation">
              <h2>Your Reservation</h2>
              <div className="synop">
                <table>
                  <tbody>
                    <tr>
                      <th>Check In</th>
                      <td>
                        { checkIn.format( 'DD/MM/YYYY' ) }
                      </td>
                    </tr>
                    <tr>
                      <th>Check Out</th>
                      <td>
                        { checkOut.format( 'DD/MM/YYYY' ) }
                      </td>
                    </tr>
                    <tr>
                      <th>Rooms</th>
                      <td>
                        { rooms.length } rooms for&nbsp;
                        { checkOut.diff( checkIn, 'days' ) } nights
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="rooms">
                { rooms.map( r =>
                    <div className="room">
                      <img src={ r.kind.look } />
                      <div className="content">
                        <small>{ r.kind.name }</small>
                        <b>{ r.name }</b>
                        <div className="guests">
                          <b>Guests</b>
                          <span className="ctl" onClick={ () => dec(r) }>
                            <i className="fa fa-minus" />
                          </span>
                          <span className="val">{ guests[r.name] }</span>
                          <span className="ctl" onClick={ () => inc(r) }>
                            <i className="fa fa-plus" />
                          </span>
                        </div>
                      </div>
                    </div>
                  ) }
              </div>
              <div className="summary">
                { summary }
                <a href="tel:727-360-4940">Call (727) 360-4940</a>
              </div>
              <div className="footnote">
                In case you need to cancel your reservation, the
                cancellation fees that will be charged equal to the
                amount of an one (1) night stay for each room.
              </div>
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/booking/Reservation.tsx
 **/